import { consentCookieHelper } from '@sainsburys-tech/boltui-utils'
import { COOKIE_CONSENT_NAME, CONSENT_CATEGORIES, ONETRUST_CATEGORIES } from '../config/cookie-consent'

let refIntervalId // Reference for the setInterval
const defaultDelay = 1000 // 1 second

// Helper to parse OneTrust OptanonConsent cookie string for category consent
export const hasOptanonCategoryConsent = (cookieValue, consentCategory) => {
  const groups = consentCookieHelper.parseOptanonGroups(cookieValue)
  if (!groups) return null

  const categoryId = ONETRUST_CATEGORIES[consentCategory]

  const optedInValue = groups[categoryId]
  if (!categoryId || !optedInValue) return null

  return optedInValue === '1' // 1 = consented, 0 = not consented
}

const getLegacyConsentCookieValue = (cookies, brand) => {
  if (
    typeof brand !== 'string' ||
    brand.length === 0 ||
    !Object.prototype.hasOwnProperty.call(COOKIE_CONSENT_NAME, brand.toUpperCase())
  )
    return ''

  const cookieName = COOKIE_CONSENT_NAME[brand.toUpperCase()]
  return consentCookieHelper.getConsentCookieValue(cookies, cookieName)
}

const hasConsentForCategory = (brand = '', consentCategory = '') => {
  const { categories, getCategorySection, hasOptedIn, getConsentCookieValue } = consentCookieHelper

  // No brand so unable to check consent
  if (!brand || !Object.prototype.hasOwnProperty.call(categories, consentCategory)) return null

  // const consentCategory = consentType
  const cookies = typeof window !== 'undefined' && window.document ? document.cookie : null

  if (!cookies || typeof cookies !== 'string') return null

  // Prefer OneTrust if present
  const oneTrustCookieValue = getConsentCookieValue(cookies, COOKIE_CONSENT_NAME.ONETRUST)
  if (oneTrustCookieValue) {
    // Use OneTrust category mapping
    return hasOptanonCategoryConsent(oneTrustCookieValue, consentCategory)
  }

  // Fallback to Tealium logic
  const consentCookieValue = getLegacyConsentCookieValue(cookies, brand)
  // No consent cookie exists - unable to check consent
  if (!consentCookieValue || !consentCookieValue.includes('consent:') || !categories[consentCategory]) {
    return null
  }

  // Full consent
  if (!consentCategory && consentCookieValue.includes('consent:true')) return true

  // Partial consent
  if (!categories[consentCategory]) {
    return false
  }

  const categorySection = getCategorySection(consentCookieValue, consentCategory)
  if (!categorySection.length && consentCookieValue.includes('consent:true')) {
    return true
  }

  return hasOptedIn(categorySection[0])
}

const startCheckingForPerformanceConsent = ({
  brand,
  noConsentCallback = () => {},
  consentCallback = () => {},
  delay = defaultDelay
}) => {
  if (refIntervalId) clearInterval(refIntervalId)
  if (
    typeof brand === 'string' &&
    brand.length > 0 &&
    typeof noConsentCallback === 'function' &&
    typeof consentCallback === 'function'
  ) {
    refIntervalId = setInterval(() => {
      const hasAllowedPerformance = hasConsentForCategory(brand, CONSENT_CATEGORIES.PERFORMANCE)
      if (typeof hasAllowedPerformance === 'boolean') {
        if (hasAllowedPerformance) consentCallback()
        else noConsentCallback()
        clearInterval(refIntervalId)
      }
    }, delay)
  }
}

const stopCheckingForPerformanceConsent = () => {
  if (refIntervalId) clearInterval(refIntervalId)
}

export { hasConsentForCategory, startCheckingForPerformanceConsent, stopCheckingForPerformanceConsent }
